
import { Button } from "@/components/ui/button";
import { ArrowLeft, PlusCircle } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function ProductsHeader() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-between mb-6">
      <h1 className="text-3xl font-bold">Lista de Produtos</h1>
      <div className="flex items-center gap-2">
        <Button 
          variant="ghost" 
          onClick={() => navigate('/')}
          className="flex items-center gap-2"
        >
          <ArrowLeft className="w-4 h-4" />
          Voltar
        </Button>
        <Button 
          onClick={() => navigate('/admin/products/new')}
          className="flex items-center gap-2 bg-blue-700 hover:bg-blue-800"
        >
          <PlusCircle className="w-4 h-4" />
          Novo Produto
        </Button>
      </div>
    </div>
  );
}
